<template>
  <div>
    <div :class="`my-4 v-label theme--${theme}`">Use Custom Theme</div>
    <v-switch
      color="blue darken-2"
      inset
      v-model="customTheme"
      @change="setCustom()"
      :label="`Custom Theme`"
    ></v-switch>

    <PrimaryPicker />
    <BackgroundPicker />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import PrimaryPicker from "@/components/customisation/theme/PrimaryPicker.vue";
import BackgroundPicker from "@/components/customisation/theme/BackgroundPicker.vue";

export default {
  components: {
    PrimaryPicker,
    BackgroundPicker,
  },

  activated() {
    this.customTheme = this.$store.getters.retrieveCustomTheme;

    console.log("-- Custom Activated");
    console.log(this.$store.getters.retrieveCustomThemeDetails);
    // this.primaryColour = '#000'
  },

  data: () => ({
    customTheme: false,
  }),

  methods: {
    ...mapActions([
      "setCustomTheme",
      "setVuetifyTheme",
      "setCustomPrimaryColour",
    ]),

    async setCustom() {
      console.log(" -- Setting Custom Theme");
      console.log(this.customTheme);
      await this.setCustomTheme(this.customTheme);

      if (this.$store.getters.retrieveCustomTheme) {
        //We Are using a custom theme so get the details and load them
        this.setVuetifyTheme(this.$store.getters.retrieveCustomThemeDetails);
      } else {
        //We're not so revert to standard Caterpoint theme
        this.setVuetifyTheme(
          this.$store.getters.retrieveCaterpointThemeDetails
        );
      }
    },
  },

  computed: {
    primaryColour: {
      get() {
        return this[this.type];
      },
      set(v) {
        console.log("-- Setting Primary");
        this[this.type] = v;
      },
    },

    backgroundColour: {
      get() {
        return this[this.type];
      },
      set(v) {
        console.log("-- Setting Background");
        this[this.type] = v;
      },
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    themeInfo() {
      console.log(this.$vuetify.theme.themes[this.theme].primary);
      return this.$vuetify.theme.themes[this.theme];
    },
  },

  watch: {
    // whenever colour changes, this function will run
    primaryColour: function (newPrimary) {
      this.setCustomPrimaryColour(newPrimary);
      this.setCustom();
    },

    // backgroundColour: function (newBackground) {
    //   this.$vuetify.theme.themes[this.theme].background = newBackground;
    //   this.$vuetify.theme.themes[this.theme].background_alt = newBackground;
    //   this.$vuetify.theme.themes[this.theme].background_off = newBackground;
    //   this.$vuetify.theme.themes[this.theme].footerColor = newBackground;
    // },
  },
};
</script>

<style lang="sass" scoped>
</style>